export default __webpack_public_path__ + "static/media/24.00dc9a64.jpg";